import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { FraksiFormPayload } from "./validation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { useQuery } from "@tanstack/react-query";

// get
const getFraksi = async (
  query?: string
): Promise<ApiResponse<DataPaginate<FraksiResponse>>> => {
  return await fetcher(query ? `master/fraksi?${query}` : `master/fraksi`);
};

export const useGetFraksi = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<FraksiResponse>>, Error>(
    ["useGetFraksi", query],
    () => getFraksi(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getFraksiId = async (
  id: number
): Promise<ApiResponse<DataObject<FraksiResponse>>> => {
  return await fetcher(`master/fraksi/${id}`);
};

export const useGetFraksiId = (id: number) => {
  return useQuery<ApiResponse<DataObject<FraksiResponse>>, Error>(
    ["useGetFraksiId", id],
    () => getFraksiId(id)
  );
};

// post
export const useFraksi = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<FraksiFormPayload>>,
    Error,
    FraksiFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<FraksiFormPayload>>> => {
      const endpoint = id ? `master/fraksi/${id}` : "master/fraksi";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<FraksiFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
